export const translations = {
  nl: {
    nav: {
      features: 'Functies',
      howItWorks: 'Hoe het werkt',
      impact: 'Impact',
      login: 'Inloggen',
      signup: 'Registreren',
      dashboard: 'Dashboard',
      logout: 'Uitloggen',
    },
    hero: {
      title: 'Alles wat je nodig hebt voor slim recyclen',
      subtitle: 'Heitje combineert gemak, technologie en duurzaamheid om recyclen moeiteloos en lonend te maken. Verzamel blikjes, verdien statiegeld en help het milieu.',
      downloadApp: 'Aan de slag',
      learnMore: 'Meer informatie',
    },
    features: {
      title: 'Slim recyclen gemakkelijk gemaakt',
      subtitle: 'Ons innovatieve platform maakt blikjesverzameling en statiegeld inleveren moeiteloos terwijl je het milieu helpt.',
      findHouseholds: {
        title: 'Vind Inzamelpunten',
        description: 'Vind huishoudens in de buurt waar je statiegeld kan ophalen. Mis nooit een statiegeld kans!',
      },
      easyScheduling: {
        title: 'Eenvoudig Ophalen Plannen',
        description: 'Plan ophaalafspraken voor alle blikjes die je hebt liggen. De ophalers zijn er enorm mee geholpen en jij hoeft ze niet weg te brengen',
      },
      instantDeposit: {
        title: 'Karma punten',
        description: 'Houd in de app bij hoeveel mensen je geholpen hebt. Iedereen blij.',
      },
    },
    howItWorks: {
      title: 'Hoe Heitje werkt',
      subtitle: 'Drie eenvoudige stappen om te verdienen met je recyclebare materialen',
      step1: {
        title: 'Verzamel Blikjes',
        description: 'Download de app om in contact te komen met huishoudens of om je blikjes aan te kunnen bieden aan iemand die wel een heitje kan gebruiken',
      },
      step2: {
        title: 'Plan Ophaalafspraak',
        description: 'Vind huishoudens in de buurt op onze interactieve kaart. Mis nooit een statiegeld kans',
      },
      step3: {
        title: 'Krijg Betaald',
        description: 'Breng je opgehaalde items weg en houd een centje in je zak. Volg je verdiensten en zie je positieve milieu-impact.',
      },
    },
    impact: {
      title: 'Een echt verschil maken',
      cansRecycled: 'Blikjes Gerecycled',
      depositsPaid: 'Statiegeld Uitgekeerd',
      activeUsers: 'Actieve Gebruikers',
      citiesCovered: 'Steden Gedekt',
    },
    testimonials: {
      title: 'Wat onze gebruikers zeggen',
      subtitle: 'Sluit je aan bij tevreden recyclers die geld verdienen terwijl ze de planeet helpen',
    },
    cta: {
      title: 'Begin vandaag nog met verdienen aan je recyclebare materialen',
      description: 'Sluit je aan bij gebruikers die al geld verdienen terwijl ze het milieu helpen. Download Heitje en begin je recycling reis.',
      downloadIos: 'Download voor iOS',
      downloadAndroid: 'Download voor Android',
      trustBadges: 'Gratis te downloaden • Directe betalingen • Landelijk beschikbaar',
    },
    footer: {
      tagline: 'Recyclen moeiteloos en lonend maken. Verzamel blikjes, verdien statiegeld en help een duurzamere toekomst voor iedereen te creëren.',
      certified: 'Gecertificeerd duurzaam platform',
      features: 'Functies',
      findCollectionPoints: 'Vind Inzamelpunten',
      schedulePickups: 'Plan Ophaalafspraken',
      trackEarnings: 'Volg Verdiensten',
      impactDashboard: 'Impact Dashboard',
      support: 'Ondersteuning',
      helpCenter: 'Helpcentrum',
      contact: 'Contact',
      becomeCollector: 'Word Verzamelaar',
      becomePartner: 'Partner worden',
      copyright: '© 2025 Heitje. Alle rechten voorbehouden. Recyclen lonend maken.',
      privacy: 'Privacybeleid',
      terms: 'Algemene Voorwaarden',
    },
    notFound: {
      title: '404',
      message: 'Pagina niet gevonden',
      backHome: 'Terug naar home',
    },
    auth: {
      signInTitle: 'Welkom terug',
      signUpTitle: 'Account aanmaken',
      email: 'E-mailadres',
      password: 'Wachtwoord',
      forgotPassword: 'Wachtwoord vergeten?',
      noAccount: 'Nog geen account?',
      hasAccount: 'Heb je al een account?',
      signInButton: 'Inloggen',
      signUpButton: 'Account aanmaken',
      signInHere: 'Inloggen',
      signUpHere: 'Registreren',
      fullName: 'Volledige naam',
      phone: 'Telefoonnummer (optioneel)',
      userType: 'Ik ben een',
      household: 'Huishouden',
      collector: 'Verzamelaar',
    },
    dashboard: {
      welcome: 'Welkom',
      stats: 'Statistieken',
      recentActivity: 'Recente afspraken',
      noActivity: 'Nog geen ophaalafspraken',
    },
    download: {
      loading: 'Laden...',
      title: 'Download Onze App',
      subtitle: 'Krijg de beste mobiele ervaring met onze native app. Beschikbaar op iOS en Android.',
      redirecting: 'We leiden je om naar de',
      appStore: 'App Store',
      googlePlay: 'Google Play',
      in: 'in',
      seconds: 'seconden...',
      notRedirected: 'Klik hieronder als je niet automatisch wordt omgeleid',
      iosTitle: 'iOS App',
      iosDescription: 'Download voor iPhone en iPad',
      downloadAppStore: 'Download op App Store',
      androidTitle: 'Android app - binnenkort beschikbaar',
      androidDescription: 'Download voor Android apparaten',
      downloadGooglePlay: 'Download op Google Play',
      yourDevice: 'Jouw apparaat',
      scanQR: 'Scan QR Code om te Downloaden',
      scanDescription: 'Open de camera van je telefoon en scan de QR code om de app te downloaden',
      iosQR: 'iOS QR Code',
      androidQR: 'Android QR Code',
      forIPhone: 'Voor iPhone & iPad',
      forAndroid: 'Voor Android',
      agreement: 'Door onze app te downloaden, ga je akkoord met ons',
      privacyPolicy: 'Privacybeleid',
    },
    privacy: {
      title: 'Privacybeleid',
      subtitle: 'Uw privacy is belangrijk voor ons. Dit beleid legt uit hoe Heitje uw persoonlijke gegevens verzamelt, gebruikt en beschermt.',
      lastUpdated: 'Laatst bijgewerkt',
    },
  },
  en: {
    nav: {
      features: 'Features',
      howItWorks: 'How it works',
      impact: 'Impact',
      login: 'Login',
      signup: 'Sign up',
      dashboard: 'Dashboard',
      logout: 'Log out',
    },
    hero: {
      title: 'Everything you need for smart recycling',
      subtitle: 'Heitje combines convenience, technology and sustainability to make recycling effortless and rewarding. Collect cans, earn deposit money and help the environment.',
      downloadApp: 'Get started',
      learnMore: 'Learn more',
    },
    features: {
      title: 'Smart recycling made easy',
      subtitle: 'Our innovative platform makes can collection and deposit return effortless while helping the environment.',
      findHouseholds: {
        title: 'Find Collection Points',
        description: 'Find nearby collection points and recycling stations with our interactive map. Never miss a deposit opportunity.',
      },
      easyScheduling: {
        title: 'Easy Scheduling',
        description: 'Schedule pickup appointments for your collected cans. The collectors really appreciate it',
      },
      instantDeposit: {
        title: 'Instant Deposit Return',
        description: 'Track in the app how many people you\'ve helped. Everyone happy.',
      },
    },
    howItWorks: {
      title: 'How Heitje works',
      subtitle: 'Three simple steps to earn with your recyclables',
      step1: {
        title: 'Collect Cans',
        description: 'Download the app to connect with households or to offer your cans to someone who can use some extra cash',
      },
      step2: {
        title: 'Schedule Pickup',
        description: 'Find households nearby on our interactive map. Never miss a deposit opportunity',
      },
      step3: {
        title: 'Get Paid',
        description: 'Receive your deposit money directly in the app. Track your earnings and see your positive environmental impact.',
      },
    },
    impact: {
      title: 'Making a real difference',
      cansRecycled: 'Cans Recycled',
      depositsPaid: 'Deposits Paid Out',
      activeUsers: 'Active Users',
      citiesCovered: 'Cities Covered',
    },
    testimonials: {
      title: 'What our users say',
      subtitle: 'Join thousands of satisfied recyclers earning money while helping the planet',
    },
    cta: {
      title: 'Start earning from your recyclables today',
      description: 'Join thousands of users already earning money while helping the environment. Download Heitje and start your recycling journey.',
      downloadIos: 'Download for iOS',
      downloadAndroid: 'Download for Android',
      trustBadges: 'Free to download • Instant payments • Available nationwide',
    },
    footer: {
      tagline: 'Making recycling effortless and rewarding. Collect cans, earn deposit money and help create a more sustainable future for everyone.',
      certified: 'Certified sustainable platform',
      features: 'Features',
      findCollectionPoints: 'Find Collection Points',
      schedulePickups: 'Schedule Pickups',
      trackEarnings: 'Track Earnings',
      impactDashboard: 'Impact Dashboard',
      support: 'Support',
      helpCenter: 'Help Center',
      contact: 'Contact',
      becomeCollector: 'Become Collector',
      becomePartner: 'Become Partner',
      copyright: '© 2025 Heitje. All rights reserved. Making recycling rewarding.',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
    },
    notFound: {
      title: '404',
      message: 'Page not found',
      backHome: 'Back to home',
    },
    auth: {
      signInTitle: 'Welcome back',
      signUpTitle: 'Create an account',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot password?',
      noAccount: 'Don\'t have an account?',
      hasAccount: 'Already have an account?',
      signInButton: 'Sign in',
      signUpButton: 'Create account',
      signInHere: 'Sign in',
      signUpHere: 'Sign up',
      fullName: 'Full name',
      phone: 'Phone number (optional)',
      userType: 'I am a',
      household: 'Household',
      collector: 'Collector',
    },
    dashboard: {
      welcome: 'Welcome',
      stats: 'Statistics',
      recentActivity: 'Recent appointments',
      noActivity: 'No pickup appointments yet',
    },
    download: {
      loading: 'Loading...',
      title: 'Download Our App',
      subtitle: 'Get the best mobile experience with our native app. Available on iOS and Android.',
      redirecting: 'Redirecting you to the',
      appStore: 'App Store',
      googlePlay: 'Google Play',
      in: 'in',
      seconds: 'seconds...',
      notRedirected: 'Click below if you\'re not redirected automatically',
      iosTitle: 'iOS App',
      iosDescription: 'Download for iPhone and iPad',
      downloadAppStore: 'Download on App Store',
      androidTitle: 'Android app - coming soon',
      androidDescription: 'Download for Android devices',
      downloadGooglePlay: 'Get it on Google Play',
      yourDevice: 'Your device',
      scanQR: 'Scan QR Code to Download',
      scanDescription: 'Open your phone\'s camera and scan the QR code to download the app',
      iosQR: 'iOS QR Code',
      androidQR: 'Android QR Code',
      forIPhone: 'For iPhone & iPad',
      forAndroid: 'For Android',
      agreement: 'By downloading our app, you agree to our',
      privacyPolicy: 'Privacy Policy',
    },
    privacy: {
      title: 'Privacy Policy',
      subtitle: 'Your privacy is important to us. This policy explains how Heitje collects, uses and protects your personal data.',
      lastUpdated: 'Last updated',
    },
  },
};

export type Language = keyof typeof translations;
export type TranslationKeys = typeof translations.nl;
